/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import PlusIcon from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core';
import {
    bool, node, object, string,
} from 'prop-types';

const styles = (theme) => ({
    addFieldLink: {
        color: theme.palette.primary?.main || '#000',
        outline: 'none',
        fontSize: '1em',
        margin: '10px 0',
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    circleAdd: {
        fontSize: '1em',
        verticalAlign: 'text-bottom',
    },
});

const DisplayLinkField = ({
    classes, linkText, val, required, flagError, children, id, plusIcon,
}) => {
    const [hideField, setShowHideField] = useState((!val && !required && !flagError));

    if (hideField && !val && !required && !flagError) {
        return (
            <div
                id={`hidden-link-${id}`}
                className={classes.addFieldLink}
                onClick={() => { setShowHideField(false); }}
                role="button"
                tabIndex="0"
                onKeyDown={() => { }}
            >
                { plusIcon ? <PlusIcon className={classes.circleAdd} /> : null}
                {linkText}
            </div>
        );
    }

    return (
        <>{children}</>
    );
};

DisplayLinkField.propTypes = {
    classes: object.isRequired,
    children: node,
    linkText: string,
    val: string,
    required: bool,
    flagError: bool,
    id: string,
    plusIcon: bool,
};

DisplayLinkField.defaultProps = {
    children: null,
    linkText: '',
    val: '',
    required: false,
    flagError: false,
    id: '',
    plusIcon: true,
};

export default withStyles(styles)(DisplayLinkField);
